module.exports = __webpack_public_path__ + "images/icons_v2/settings-filled-cfc4d639.svg";